import { CludoWrapper, CludoSearchOptions } from '@cludosearch/cludo-search-components';
import { SupportedLanguage } from '@cludosearch/cludo-search-components/dist/types/translation-types';
import React, { useEffect, useState } from 'react';

declare global {
	interface Window {
		STORIES: unknown[];
	}
}

export interface CludoContextConfig {
	siteid: string;
	customerId: number;
	engineId: number;
	locale: 'kl-gl' | 'da' | 'en';
	searchTag?: string;
}

export const CludoContext = (props: { config?: CludoContextConfig; children: React.ReactNode }) => {
	const { siteid, customerId = 3478, engineId = 14584, locale = 'da', searchTag } = props?.config ?? {};
	const language = locale as SupportedLanguage; // kl-gl is not currently supported by Cludo
	const [LazyCludoWrapper, setLazyCludoWrapper] = useState(null);

	const cludoSearchConfig: CludoSearchOptions = {
		customerId,
		engineId,
		cssTheme: '',
		searchUrl: '/',
		language,
		filters: {
			Language: [],
			'search-site': [siteid],
		},
		autocomplete: {
			useSearchAsYouType: true,
		},
		tracking: {
			disableExtendedTracking: true,
		},
		facets: {
			keys: ['Category'],
			defaultValues: {
				Category: searchTag ? [searchTag] : [],
			},
		},
		behavior: {
			updateUrlOnSearch: false,
			allowSearchWithoutSearchword: searchTag ? true : false,
		},
	};

	useEffect(() => {
		if (typeof window !== 'undefined') {
			import('@cludosearch/cludo-search-components').then((mod) => {
				setLazyCludoWrapper(() => mod.CludoWrapper);
			});
		}
	}, []);

	if (typeof window !== 'undefined' && window?.STORIES?.length) return <CludoWrapper config={cludoSearchConfig}>{props.children}</CludoWrapper>;
	if (!LazyCludoWrapper) return <>{props.children}</>;
	return <LazyCludoWrapper config={cludoSearchConfig}>{props.children}</LazyCludoWrapper>;
};
